import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const categoriesApi = createApi({
  reducerPath: "categoriesApi",
  baseQuery: customFetchBase({ url: "categories" }),
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: ({ page = 1, search, code } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&search=${search}`;
        if (code) url += `&code=${code}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useGetCategoriesQuery } = categoriesApi;
